import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=49655894&scoped=true&"
import script from "./SearchItem.vue?vue&type=script&lang=js&"
export * from "./SearchItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=49655894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49655894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49655894')) {
      api.createRecord('49655894', component.options)
    } else {
      api.reload('49655894', component.options)
    }
    module.hot.accept("./SearchItem.vue?vue&type=template&id=49655894&scoped=true&", function () {
      api.rerender('49655894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bulk-items-list/SearchItem.vue"
export default component.exports